<template>
    <div>
        <div style="background: #ffffff;position:relative;">
            <div class="search-condition-con" :class="'show'">
                <div class="search-condition">
                    <span class="label">站点</span>
                    <div class="input-condition">
                        <site-auto-complete v-model="condition.site_id" ref="subwaySear"></site-auto-complete>
                    </div>
                </div>
                <el-button type="primary" @click="handleSearch" class="subway-search-btn">查 询</el-button>
                <el-button  @click="resetSearch()" class="subway-search-btn">清空条件</el-button>

            </div>
        </div>
        <div class="level-container">
            <div class="level-list">
                <div class="area" v-for="(data, index) in list" :key="data.id">
                    <h1 class="title">{{data.name}}</h1>
                    <div class="level-content">
                        <div class="plus-btn" @click.stop.prevent="operateAdd(data)" v-if="isAllowAdd(data, index)" style="display:none">
                            <el-button size="small">
                                <i class="el-icon-plus"></i>
                                新增
                            </el-button>
                        </div>
                        <div class="level-item level-flex" v-if="editCode === `${data.type}_add`">
                            <el-input v-model="addAreaText" class="list-input ml0"></el-input>
                            <div class="icon-edit-operation-list">
                                <i class="el-icon-check icon-ope" @click.stop.prevent="confirmAdd(data.type)"></i>
                                <i class="el-icon-close icon-ope" @click.stop.prevent="cancelAdd()"></i>
                            </div>
                        </div>
                        <div class="level-item"
                            v-for="(area, key) in dataList[data['key']]"
                            :key="key"
                            :class="getClass(area, data.type)"
                        >
                            <span class="label">{{area.id}}</span>
                            <div class="level-flex" v-if="editCode !== data.type + '_'+ area.id">
                                <span class="list" @click.stop.prevent="getDetail(index, area, data.type)">{{area.name}}</span>
                                <div class="icon-operation-list" v-if="!data.isNotOperation">
                                    <i class="el-icon-edit-outline icon-ope" @click.stop.prevent="editCode = `${data.type}_${area.id}`" v-if="data.type === 'subway'"></i>
                                    <i class="el-icon-edit-outline icon-ope" @click.stop.prevent="operateEdit(area)" v-else></i>
                                    <i class="el-icon-back icon-ope icon-ope-up" @click.stop.prevent="translatePosition(data.type, true, key, area)" v-if="dataList[data['key']].length > 1"></i>
                                    <i class="el-icon-back icon-ope icon-ope-down" @click.stop.prevent="translatePosition(data.type, false, key, area)" v-if="dataList[data['key']].length > 1"></i>
                                    <i class="el-icon-delete icon-ope" @click.stop.prevent="deleteArea(data.type, area, key)"></i>
                                </div>
                            </div>
                            <div class="level-flex" v-else>
                                <el-input v-model="area.modelValue" class="list-input"></el-input>
                                <div class="icon-edit-operation-list">
                                    <i class="el-icon-check icon-ope" @click.stop.prevent="confirmEdit(data.type, area, key)"></i>
                                    <i class="el-icon-close icon-ope" @click.stop.prevent="cancelEdit(area)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 添加地铁站 -->
            <AddStation ref="addStationRef" :stationCallback="stationCallback" />
        </div>
    </div>
</template>
<script>
import {getSite, getSubways, getSubwayStations, createSubways, editSubways, deleteSubways, deleteSubwayStations, sortSubways, sortSubwayStations} from '@/service/site'
import AddStation from './components/AddStation'
import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
export default {
    name: 'List',
    components: {
        SiteAutoComplete,
        AddStation
    },
    data () {
        const list = [
            { key: 'city_list', type: 'city', name: '城市站点', isNeedAdd: false, isNotOperation: true},
            { key: 'subway_list', type: 'subway', name: '地铁线路', isNeedAdd: true},
            { key: 'subway_station_list', type: 'subway_station', name: '地铁站点', isNeedAdd: true},
        ]
        let info = { dataList: {}, list: list }
        list.map((item) => {
            info[`current_${item.type}`] = {}
            info.dataList[`${item.type}_list`] = []
        })
        return {
            isAddArea: false,
            addAreaText: '',
            editCode: '',
            ...info,
            condition: {
                site_id: '',
                site_name: ''
            }
        }
    },
    mounted () {
        this.initList(-1)
    },
    methods: {
        async initList (type = -1) {
            const loading = this.$loading({
                lock: true,
                spinner: 'el-icon-loading',
                text: '正在请求数据，请稍后',
                background: 'rgba(0, 0, 0, 0.1)',
                customClass: 'level-loading'
            })
            for (let i = type; i < 2; i ++) {
                
                try {
                    await this.initData(i)
                } catch (error) {
                    const message = error.name ? error.name[0] : error.message || '查询数据失败!'
                    this.$message({
                        type: 'error',
                        message: message
                    })
                    loading.close()
                }
            }
            loading.close()
        },
        async initData (type = -1) {
            const target = this.list[type < 0 ? 0 : type]
            const upId = this[`current_${target['type']}`].id || -1
            if (upId === -1 && type >= 0) return null
            let resultList = []
            if (type < 0) {
                const list = await getSite({
                    'per_page' : 9999,
                    id: this.condition.site_id,
                    name: this.condition.site_name
                })
                resultList = list.data || []
            } else if (type < 1) {
                resultList = await getSubways(upId)
            } else if (type < 2) {
                resultList = await getSubwayStations(upId)
            }
            const opeTarget = this.list[type + 1] || {}
            if (opeTarget.type === 'subway') {
                resultList = resultList.map(v => {
                    v.modelValue = v.name
                    return v
                })
            }
            this[`current_${opeTarget.type}`] = resultList[0] || {}
            this.$set(this.dataList, opeTarget.key, resultList)
        },
        handleSearch () {
            this.list.map((item) => {
                this[`current_${item.type}`] = {}
                this.$set(this.dataList, `${item.type}_list`, [])
            })
            this.initList(-1)
        },
        getClass (row, type) {
            let className = ''
            if (row.id === this[`current_${type}`].id) className += ' active'
            if (this.editCode === type + '_' + row.id) className += ' is-edit'
            return className
        },
        getDetail (index, data, type) {
            this.list.map((v, key) => {
                if (key > index) {
                    this.$set(this.dataList, v['key'], [])
                    this[`current_${v['type']}`] = {}
                }
            })
            this[`current_${type}`] = data
            this.initList(index)
        },
        isAllowAdd (data, index) {
            // 当前允许添加操作并且非跳级
            const prevData = this.list[index - 1] || {}
            if (!data.isNeedAdd) return false
            const current = this[`current_${prevData['type']}`]
            if (!current.id) return false
            return true
        },
        /** 新增按钮触发操作 */
        operateAdd (data) {
            if (data.type === 'subway') {
                this.editCode = `${data.type}_add`
            } else if (data.type === 'subway_station') {
                this.$refs.addStationRef && this.$refs.addStationRef.openMenu(this.current_subway.id, this.current_city.name)
            }
        },
        /** 新增地铁线路逻辑 */
        async confirmAdd (type) {
            if (this.addAreaText.length <= 0 || this.addAreaText.length > 10) {
                this.$message({
                    type: 'error',
                    message: '地铁线路长度在2-10个字符之间'
                })
                return null
            }
            if (!/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(this.addAreaText)) {
                this.$message({
                    type: 'error',
                    message: '地铁线路长度不能包含特殊字符'
                })
                return null
            }
            const loading = this.$loading({
                lock: true,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.05)',
                customClass: 'level-loading'
            })
            try {
                const data = await createSubways(this.current_city.id, {
                    name:  this.addAreaText
                })
                loading.close()
                this.dataList[`${type}_list`].unshift({ id: data.id, name: this.addAreaText, modelValue: this.addAreaText })
                this.cancelAdd()
                this.$message({
                    type: 'success',
                    message: '新增地铁线路成功'
                })
            } catch (error) {
                const message = error.name ? error.name[0] : error.message || '新增地铁线路失败'
                this.$message({
                    type: 'error',
                    message: message
                })
            }
        },
        /** 新增地铁站点回调 */
        stationCallback (data, status) {
            if (status) {
                let list = this.dataList[`subway_station_list`]
                list = list.map(v => {
                    if (v.id === data.id) v = data
                    return v
                })
                this.$set(this.dataList, 'subway_station_list', list)
            } else {
                this.dataList[`subway_station_list`].unshift(data)
            }
        },
        /** 取消新增 */
        cancelAdd () {
            this.addAreaText = ''
            this.editCode = ''
        },
        /** 编辑站点触发 */
        operateEdit (data) {
            this.$refs.addStationRef && this.$refs.addStationRef.openMenu(this.current_subway.id, this.current_city.name, data)
        },
        /** 编辑逻辑处理 */
        async confirmEdit (type, data, index) {
            if (data.modelValue.length <= 0 || data.modelValue.length > 10) {
                this.$message({
                    type: 'error',
                    message: '地铁线路长度为2-10个字符之间'
                })
                this.cancelEdit()
                return null
            }
            if (!/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(data.modelValue)) {
                this.$message({
                    type: 'error',
                    message: '地铁线路长度不能包含特殊字符'
                })
                this.cancelEdit()
                return null
            }
            try {
                await editSubways(this.current_city.id, data.id, {
                    name: data.modelValue
                })
                this.$set(data, 'name', data.modelValue)
                this.$set(data, 'modelValue', data.modelValue)
                this.editCode = ''
                this.$message({
                    type: 'success',
                    message: '编辑地铁线路成功'
                })
            } catch (error) {
                const message = error.name ? error.name[0] : error.message || '编辑地铁线路失败'
                this.$message({
                    type: 'error',
                    message: message
                })
            }
        },
        /** 取消编辑 */
        cancelEdit (data) {
            this.$set(data, 'modelValue', data.name)
            this.editCode = ''
        },
        /** 删除逻辑处理 */
        deleteArea (type, data, index) {
            this.$confirm('删除后，将删除前台及后台的数据显示，不能恢复，是否确认？', '删除提示', {
                center: 'center'
            }).then(async () => {
                try {
                    if (type === 'subway') {
                        await deleteSubways(this.current_city.id, data.id)
                        this.dataList['subway_list'].splice(index, 1)
                    }
                    else if (type === 'subway_station') {
                        await deleteSubwayStations(this.current_subway.id, data.id)
                        this.dataList['subway_station_list'].splice(index, 1)
                    }
                } catch (error) {
                    this.$message({
                        type: 'error',
                        message: error.message || '删除操作失败'
                    })
                }
            })
        },
        /** 排序逻辑处理 */
        async translatePosition (type, status, index, data) {
            let result = {}
            const newIndex = status ? index - 1 : index + 1
            const list = this.dataList[`${type}_list`]
            if (newIndex === -1 || newIndex === list.length) return null
            const query = { sort: status ? 1 : 2 }
            try {
                if (type === 'subway') result = await sortSubways(this.current_city.id, data.id, query)
                else if (type === 'subway_station') result = await sortSubwayStations(this.current_subway.id, data.id, query)
                list[index] = list.splice(newIndex, 1, list[index])[0]
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: error.message || '排序操作失败'
                })
            }
        },
         resetSearch(){//清空搜索条件，刷新页面
            this.$refs.subwaySear.onClean();
            this.initList(-1)
    },
    }
}
</script>
<style scoped>
.level-container .area{
    min-width:250px;
}
.ml0{
    margin-left: 0 !important;
}
div .active{
    border-bottom: ridge;
    border-top: ridge;
}
.subway-search-btn{
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
}
</style>
